interface LeadCaptureFormConfig {
  listing_enquiry_form: {
    form_id: string;
    name_field_id: string;
    phone_field_id: string;
    accept_terms_field_id: string;
  };
  leadCaptureFormUrl: string;
}
interface FormData {
  firstName: string;
  mobileNum: string;
  isChecked: boolean;
}

type SuccessfulResponse = {
  responseData: {
    formId: number;
    emarsysId: null | string;
    errors: string[];
    id: number;
  };
};

type ErrorResponse = {
  responseData: {
    error: string;
  };
};

export const fetchToken = async (
  config: LeadCaptureFormConfig,
): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append('form_id', config.listing_enquiry_form.form_id);
    formData.append('rea-form-token', '1');
    const response = await fetch(config.leadCaptureFormUrl, {
      method: 'POST',
      body: formData,
    });
    const responseData = await response.json();
    if (!responseData) {
      throw new Error('Empty response data');
    }
    return responseData.token as string;
  } catch (error) {
    console.error('Error fetching token:', error);
    throw error;
  }
};
export const handleLeadsSubmit = async (
  formData: FormData,
  token: string,
  config: LeadCaptureFormConfig,
  projectId: number,
  listingId: string,
): Promise<
  { responseData: SuccessfulResponse | ErrorResponse } | { error: Error }
> => {
  try {
    const formdata = new FormData();
    formdata.append('token', token);
    formdata.append('type', '1');
    formdata.append(
      `field[${config.listing_enquiry_form.name_field_id}]`,
      formData.firstName,
    );
    formdata.append(
      `field[${config.listing_enquiry_form.phone_field_id}]`,
      formData.mobileNum,
    );
    formdata.append(
      `field[${config.listing_enquiry_form.accept_terms_field_id}]`,
      '1',
    );
    formdata.append('rea-form-submission', config.listing_enquiry_form.form_id);
    formdata.append('projectId', projectId.toString());
    formdata.append('listingId', listingId);
    formdata.append('fastDeal', 'true');

    const response = await fetch(`${config.leadCaptureFormUrl}`, {
      method: 'POST',
      headers: {},
      body: formdata,
    });

    if (!response.ok) {
      throw new Error('Failed to submit form');
    }
    const responseData = await response.json();

    return { responseData };
  } catch (error) {
    console.error('Error submitting form:', error);
    return { error };
  }
};
